import { render } from "./Menu.component.vue?vue&type=template&id=6e671b67&scoped=true&ts=true"
import script from "./Menu.component.vue?vue&type=script&lang=ts"
export * from "./Menu.component.vue?vue&type=script&lang=ts"

import "./Menu.component.vue?vue&type=style&index=0&id=6e671b67&scoped=true&lang=scss"

import exportComponent from "/builds/anisen/datamanagerweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e671b67"]])

export default __exports__